import { useLocation, useNavigate } from "react-router-dom";
import { ApplicationStatusNames } from "utilities/Constant";
import { ConsentStatus, useGetInterimDashboardQuery } from "pages/application/applicationService";
import { useDispatch, useSelector } from "react-redux";
import { getApplicationRoutingData, getNhDealApplicationId, getCurrentUserId, setIsInterimDashboard } from "features/authSlice";
import { RegistrationRoleType } from "pages/registration/registrationService";
import { useEffect } from "react";

const usePerformRouting = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const authRoutingData = useSelector(getApplicationRoutingData);
  const id = useSelector(getNhDealApplicationId);
  const userId = useSelector(getCurrentUserId);
  const { data: hasInterimDashboard, isSuccess, isFetching } = useGetInterimDashboardQuery({ id, userId });

  const dispatch = useDispatch();
  const getRouteForApplicationPath = (nhApplicationId?: string): string => {
    return nhApplicationId ? "/application" : "/path";
  };

  const isNavigateToPreviewPAL = (searchParams: URLSearchParams): boolean => {
    const hasPalInstanceId = searchParams.has("palInstanceId");
    const hasId = searchParams.has("Id");
    return hasPalInstanceId && hasId && Array.from(searchParams.keys()).length > 0;
  };

  useEffect(() => {
    if (!isFetching && isSuccess && hasInterimDashboard !== undefined) {
      performRouting();
    }
  }, [isSuccess, hasInterimDashboard, isFetching]);

  const performRouting = () => {
    const searchParams = new URLSearchParams(search);
    if (!isSuccess) {
      return;
    }

    const { nhApplicationStatus, applicationId, borrowerConsentStatus, coBorrowerConsentStatus, userRole } = authRoutingData;
    const hasAllConsents = (consentStatus: ConsentStatus) => {
      return consentStatus.isDataSharingCollected && consentStatus.isTCPACollected && consentStatus.isEConsentCollected;
    };

    const hasNoConsents = (consentStatus: ConsentStatus) => {
      return !consentStatus.isDataSharingCollected && !consentStatus.isTCPACollected && !consentStatus.isEConsentCollected;
    };

    const currentConsentStatus =
      (userRole as string).toLowerCase() === RegistrationRoleType.Borrower.toLowerCase() ? borrowerConsentStatus : coBorrowerConsentStatus;

    const isCompletedOrHasInterimDashboard =
      nhApplicationStatus?.toLowerCase() === ApplicationStatusNames.Completed.toLowerCase() ||
      (hasInterimDashboard && hasAllConsents(currentConsentStatus));

    if (hasInterimDashboard && hasNoConsents(currentConsentStatus)) {
      navigate("/interim-welcome", { replace: true });
    } else if (isCompletedOrHasInterimDashboard) {
      dispatch(setIsInterimDashboard(hasInterimDashboard));
      if (!isNavigateToPreviewPAL(searchParams)) {
        navigate("/dashboard", { replace: true });
      }
    } else {
      navigate(getRouteForApplicationPath(applicationId), { replace: true });
    }
  };
  return { isSuccess, performRouting };
};

export default usePerformRouting;
